/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDateRangeInput = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.001 1v2H15V1h2.001v2H23v20H1V3h6.001V1zm-6 4L3 21h18V5h-3.999v1.999H15V5H9.001v1.999h-2V5zm13.597 5.55 2.65 2.698L20 14l-.007.006.007.006-.697.684-2.717 2.718L15.172 16l.999-1H7.855l1 1-1.415 1.414-2.7-2.702-.714-.7.006-.007L4.026 14l.737-.738 2.665-2.712 1.426 1.402L7.825 13h8.376l-1.03-1.047z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDateRangeInput as DateRangeInput };
